import React from "react";

import { Grid, Box } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

const CLientsLoading: React.FC = () => {
  return (
    <>
      <Grid container spacing={3} direction="column">
        {[...Array(6)].map((_, index) => (
          <Grid item xs={12} key={index}>
            <Box display="flex" alignItems={"center"} m={2}>
              <Box marginRight={55} display="flex" alignItems={"center"}>
                <Skeleton variant="circular" width={40} height={40} />
                <Box marginRight={4} />
                <Skeleton variant="text" width={150} height={24} />
              </Box>

              <Box>
                <Box display="flex" alignItems="center">
                  <Skeleton variant="text" width={150} height={24} />
                  <Box marginRight={4} />
                  <Skeleton variant="text" width={40} height={12} />
                </Box>
                <Box marginBottom={2} />
                <Box display="flex" alignItems="center">
                  <Skeleton variant="text" width={100} height={14} />
                  <Box marginRight={4} />
                  <Skeleton variant="text" width={100} height={14} />
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
export default CLientsLoading;
